import { Component, OnInit, ViewEncapsulation, Input, Inject } from '@angular/core';
import { UserProfileService } from './user-profile.service';
import { LanguageService } from '../../../core/language/language.service';
import { AuthService } from '../../../core/auth/auth.service';
import { ItauUserIdleService } from '../../../core/security/itau-user-idle.service';
import { SdkAnalyticsService } from '@app/shared/services/sdk-analytics/sdk-analytics.service';
import { normalizePath } from '@app/shared/utils';
import { Router } from '@angular/router';

const defaultSiteLanguage = 'br';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class UserProfileComponent implements OnInit {

  titleConfiguration: string;
  optionConfiguration: Array<string>;
  isMenuClosed: boolean;
  language: string;
  titleLanguage: string;
  titleProfile: string;
  optionMyProfile: Array<string>;

  canChangeManager: boolean = false;
  changeManagerUrl: string;

  constructor(private service: UserProfileService, private itauUserIdleService: ItauUserIdleService, private languageService: LanguageService, private authService: AuthService, @Inject('Window') private _window: Window,
    private _sdkAnalyticsService: SdkAnalyticsService, private router: Router
  ) { }

  logout() {
    if (this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: "perfil-configuracoes:logout"
      });
    }
    this.itauUserIdleService.stopWatching();
    this.authService.logout(true);
  }

  changeSiteLanguage(event, language: string) {
    if (language && this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: "perfil-configuracoes:idioma:" + language
      });
    }
    event.stopPropagation();
    this.setLanguage(language);
    this.service.changeSiteLanguage(language);
  }

  setMenuOpened(isClosed: boolean) {
    this.isMenuClosed = isClosed;
  }

  ngOnInit() {
    if (this.authService.currentUserValue && this.authService.currentUserValue.permiteTrocaGestor) {
      this.canChangeManager = true;
    }
  }

  get siteLanguage() {
    return this.languageService.siteLanguage ? this.languageService.siteLanguage : defaultSiteLanguage;
  }

  get languageIsBR() {
    return this.siteLanguage === 'br';
  }

  get languageIsUS() {
    return this.siteLanguage === 'us';
  }

  get languageIsES() {
    return this.siteLanguage === 'es';
  }

  setLanguage(language: string) {
    this.language = language.toLowerCase();
  }

  changeManager(): void {
    if (this.router && this.router.url) {
      this._sdkAnalyticsService.trackEvent('click', {
        custom_path: normalizePath(this.router.url),
        implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
        detail: "perfil-configuracoes:troca-gestor"
      });
    }
    this.changeManagerUrl = this.authService.currentUserValue.permiteTrocaGestor;
    let titleChangeManager = this.languageService.translate('titleChangeManager.TITLE');
    this._window.open(this.changeManagerUrl, titleChangeManager, 'width=800,height=600');
    this._sdkAnalyticsService.trackEvent('screen_view', {
      custom_path: '/iss/lg/pesquisadegestor',
      implementation_team: "output-de-dados-do-ativo-monitores-de-status:experiencia-do-cliente",
      detail: 'perfil-configuracoes:troca-gestor'
    });
  }
}
